﻿import { IContactName, ContactName } from "../ContactName";
import { PostalAddress, IPostalAddress } from "./PostalAddress";
import { Customer } from "./Customer";

export class CustomerAddress implements ICustomerAddress {
    constructor(address?: ICustomerAddress, customer?: Customer) {
        // initialize typed object from generic object
        this._customer = customer;
        this.addressCode = (address ? address.addressCode : undefined) ?? "PRIMARY";
        this.companyName = address ? address.companyName :  undefined;
        this.contactPerson = address ? address.contactPerson : undefined;
        this.postal = new PostalAddress(address ? address.postal : undefined, this);
        this.phone = address ? address.phone : undefined;
        this.email = address ? address.email : undefined;
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return {
            addressCode: this.addressCode,
            companyName: this.companyName || undefined,
            contactPerson: this.contactPerson.toJSON(),
            postal: this.postal.toJSON(),
            phone: this.phone || undefined,
            email: this.email || undefined
        };
    }

    addressCode: string;
    companyName?: string;
    contactName?: string;
    get contactPerson(): ContactName {
        return new ContactName(this.contactName);
    }
    set contactPerson(value: IContactName | string | undefined) {
        if (typeof value === "string") {
            this.contactName = value ?? "";
        } else {
            this.contactName = value ? new ContactName(value).toString() : "";
        }
    }
    postal: PostalAddress;
    phone?: string;
    email?: string;

    private _customer?: Customer;

    // Calculated properties

    get customerNumber(): string|undefined {
        return this._customer?.customerNumber;
    }

    toString(singleLine: boolean = false): string {
        let lines = this.contactPerson.toString();

        const postal = this.postal.toString(singleLine);
        if (postal) {
            if (lines.length) lines += "\r\n";
            lines += postal;
        }
        if (this.phone) {
            if (lines.length) lines += "\r\n";
            lines += this.phone;
        }

        if (this.email) {
            if (lines.length) lines += "\r\n";
            lines += this.email;
        }

        if (singleLine)
            lines = lines.replace("\r\n", " &#x25CF; ");

        return lines;
    }
}


export interface ICustomerAddress {
    addressCode: string;
    companyName?: string;
    contactPerson?: IContactName;
    contactName?: string;
    postal?: IPostalAddress;
    phone?: string;
    email?: string;
}
